import React ,{useEffect} from 'react';
import AOS from 'aos';
import Banner from '../Components/Pages/Customer/Banner';
import Stories from '../Components/Pages/Customer/Stories';
import Header from '../Components/Shared/Header/Header';
import Start from '../Components/Shared/Start/Start';
import Footer from '../Components/Shared/Footer/Footer';
import Testimonial from '../Components/Pages/Customer/Testimonial';
function Customer(){
    useEffect(() => {
        AOS.init({
          duration: 800,
          disable: 'mobile',
          once: true,
        });
      }, []);
    return(
        <>
        <Header />
        <Banner />
        <Testimonial />
        <Stories />
        <Start />
        <Footer />
        </>
    )
};
export default Customer ;